import React from "react";
import { Col, Row } from "react-bootstrap";
import StatCardGroup from "../Common/StatCardGroup";
import MembershipGrowthChart from "./MembershipGrowthChart";
import SentimentAnalysis from "./SentimentAnalysis";
import DonutDistribution from "../Common/DonutDistribution";
import RevenueSplit from "./RevenueSplit";
import { primaryColor } from "utils/dashboardUtils";
import RecentActivity from "./RecentActivity";
import { useSelector } from "react-redux";

const Customers = () => {
  // Stats Data
  const statsData = useSelector((state) => state.Dashboard?.data?.stats);
  const customerData = statsData?.stats;
  // Charts Data
  const chartsData = useSelector((state) => state.Dashboard?.data?.charts);
  const membershipGrowthData = chartsData?.membershipGrowth;
  const feedbacks = chartsData?.feedbacks;

  // donutChart Data
  const donutChartData = useSelector(
    (state) => state.Dashboard?.data?.donutChart,
  );
  const membershipDistributionData = donutChartData?.membershipDistribution;
  const singleWashDistributionData = donutChartData?.singleWashDistribution;
  const revenueSplitData = donutChartData?.revenueSplit;

  const DASHBOARD_STATS = [
    {
      id: "totalCustomers",
      title: "Total Customer",
      value: customerData?.totalCustomers,
      icon: "totalCustomers",
      month: "Current Month",
    },
    {
      id: "newCustomer",
      title: "New Customer",
      value: customerData?.newCustomer,
      icon: "newCustomer",
      month: "Current Month",
    },
    {
      id: "churnRate",
      title: "Churn Rate",
      value: customerData?.churnRate,
      icon: "churnRate",
    },
    {
      id: "appAdoptionRate",
      title: "App Adoption Rate",
      value: customerData?.appAdoptionRate,
      icon: "appAdoptionRate",
    },

    {
      id: "newMembership",
      title: "New Membership",
      value: customerData?.newMemberships,
      icon: "newMembership",
    },
    {
      id: "retentionRate",
      title: "Retention Rate",
      value: customerData?.retentionRate,
      icon: "retentionRate",
    },
    {
      id: "customerLifetimeValue",
      title: "Customer Lifetime Value",
      value: customerData?.customerLifetimeValue,
      icon: "customerLifetimeValue",
    },
    {
      id: "usageRate",
      title: "Membership Usage Rate ",
      value: customerData?.membershipUsagePercentage,
      icon: "usageRate",
    },
  ];

  const PLAN_COLORS = {
    "Unlimited Shine": "#F3AA41",
    "Unlimited Protect": "#523677",
    "Unlimited The Works": "#DE235C",
    "Unlimited Shine Wash Plan": "#6BC4A8",
    "Basic Wash": "#4F46E5",
    "Premium Gold Plan": "#D4AF37",
    "Test Plan": "#9CA3AF",
  };

  const MEMBERSHIP_DISTRIBUTION = membershipDistributionData?.map((item) => ({
    name: item.planTitle?.en || item.label,
    value: item.value,
    color: PLAN_COLORS[item.planTitle?.en || item.label] || "#CBD5E1",
  }));

  const WASH_COLORS = {
    Shine: "#F3AA41",
    Clean: "#4F46E5",
    Protect: "#523677",
    "Gold Wash": "#D4AF37",
    Works: "#DE235C",
  };

  const SINGLE_WASH_DISTRIBUTION = singleWashDistributionData?.map((item) => ({
    name: item.washType?.en || item.label,
    value: item.value,
    color: WASH_COLORS[item.washType?.en || item.label] || "#CBD5E1",
  }));

  const REVENUE_SPLIT_DATA = [
    {
      label: "Memberships",
      value: revenueSplitData?.memberships,
      color: primaryColor,
    },
    {
      label: "Single Wash",
      value: revenueSplitData?.singleWash,
      color: "#F6A04D",
    },
  ];

  return (
    <div className="customers_dashboard">
      <StatCardGroup items={DASHBOARD_STATS} />
      <Row>
        <Col xxl={8} xl={7}>
          <MembershipGrowthChart membershipGrowth={membershipGrowthData} />
        </Col>
        <Col xxl={4} xl={5}>
          <SentimentAnalysis feedbacks={feedbacks} />
        </Col>
      </Row>
      <Row>
        <DonutDistribution
          title="Membership Distribution"
          data={MEMBERSHIP_DISTRIBUTION || []}
        />
        <DonutDistribution
          title="Single Wash Distribution"
          data={SINGLE_WASH_DISTRIBUTION || []}
        />
        <RevenueSplit title={"Revenue Split"} data={REVENUE_SPLIT_DATA} />
      </Row>
      <Row>
        <Col lg={12}>
          <RecentActivity />
        </Col>
      </Row>
    </div>
  );
};

export default Customers;
